import React, { useEffect, useState } from "react";
// import Badge from "../../../../Components/Badge/Badge";
import Pagination from "../../../../Components/Pagination/Pagination";
import SkeletonLoading from "../../../../Components/Skeleton/SkeletonLoading";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import SVG from "react-inlinesvg";
// import { useNavigate } from "react-router-dom";

type Props = {
  TableType?: string;
  CustomTable?: boolean;
  tableData?: Array<any>;
  dataLength?: number;
  customClass?: string;
  backgroundColor?: string;
  fontColor?: string;
  rowsPerPage: number;
  page_number: number;
  loading: boolean;
  setPageNumber: (value: number) => void;
  onAlertClick?: ()=>void
}

function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value?.slice(1);
}

// function lightOrDark(color: any) {
//   color = +("0x" + color?.slice(1).replace(color.length < 5 && /./g, "$&$&"));
//   var r = color >> 16;
//   var g = (color >> 8) & 255;
//   var b = color & 255;
//   var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
//   if (hsp > 127.5) {
//     return "light";
//   } else {
//     return "dark";
//   }
// }

export default function DashboardPatientListTable({
  CustomTable,
  customClass,
  backgroundColor,
  fontColor,
  tableData,
  dataLength = 0,
  TableType,
  rowsPerPage,
  page_number,
  loading,
  setPageNumber,
  ...args
}: Props) {
  const [tableDataList, setTableDataList] = useState(tableData);
  const [isPagination, setIsPagination] = useState<boolean>(false);
  // const mode = lightOrDark(fontColor);
  // const navigate = useNavigate();

  useEffect(() => {
    if (tableData!.length === 0) {
      setIsPagination(false)
    } else {
      setIsPagination(true)
    }
    setTableDataList(tableData);
  }, [rowsPerPage, tableData]);

  // const onAlertClick = (id: number) => {
  //   navigate(`/patientprofile/${id}`)
  // }

  const loadingData=[];
  for (let index = 0; index < rowsPerPage; index++) {
    loadingData.push(
      <tr className={`hoversuccess`}>
        <td className="name">
          {loading?<SkeletonLoading />:""} <br />
          {loading?<SkeletonLoading width={100} height={10} />:""}
        </td>
        {/* <td className="text-center">
        {loading?<SkeletonLoading />:""}
        </td> */}
        <td>
        {loading?<SkeletonLoading />: ""}
        </td>
        {/* <td className="text-center">
        {loading?<SkeletonLoading />:""}
        </td>
        <td className="text-center">
        {loading?<SkeletonLoading />: ""}
        </td>
        <td className="text-center">
        {loading?<SkeletonLoading />:""}
        </td> */}
        {/* <td className="alert-cell">
        {loading?<SkeletonLoading />:""}
        </td> */}
      </tr>
    );
  }

  return (
    <>
      <div className="card-body">
        <table className={`custom-table ${ CustomTable ? "" : "success" } ${customClass}`} style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={CustomTable ? { background: backgroundColor, color: fontColor } : {} }>
                Patient
              </th>
              {/* <th style={ CustomTable ? { background: backgroundColor, color: fontColor } : {}} className="text-center">
                Medical Condition{" "}
              </th> */}
              <th style={ CustomTable ? { background: backgroundColor, color: fontColor } : {} }>
                Shipment status
              </th>
              {/* <th style={ CustomTable ? { background: backgroundColor, color: fontColor } : {} } className="text-center">
                Kiddo Adherence
              </th>
              <th style={ CustomTable ? { background: backgroundColor, color: fontColor } : {} } className="text-center">
                Care Plan Adherence
              </th>
              <th style={ CustomTable ? { background: backgroundColor, color: fontColor } : {} } className="text-center">
                Medication Adherence
              </th> */}
              {/* <th style={ CustomTable ? { background: backgroundColor, color: fontColor } : {} } className="alertHead">
                {" "}
                Alerts
              </th> */}
            </tr>
          </thead>
          <tbody>
            {tableDataList && !loading ? (
              dataLength === 0 ? (
                <tr>
                  <td className="text-center spacer-y" colSpan={3}> 
                    There are no patients on the watch list, please order kiddo for your patients.
                  </td>
                </tr>
              ) : (
                  tableDataList.map((data: any, index: number) => (
                    <tr key={`history${index}`}
                      // className={`hover${data.alerttype ? data.alerttype : "success"}`}
                      className={"hoversuccess"}
                      // onClick={() => onAlertClick(index)}
                      >
                      <td className="name">
                        {(data.firstname + " " + data.lastname).length > 30 ? (
                          <OverlayTrigger delay={{ hide: 450, show: 300 }} overlay={(props) => (<Tooltip {...props}>{data.firstname + " " + data.lastname}</Tooltip>)} placement="bottom">
                            <label style={{ width: "215px", fontSize: "20px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {data.firstname + " " + data.lastname}
                            </label>
                          </OverlayTrigger>
                        ) : (
                          <>
                            {data.firstname + " " + data.lastname}
                          </>
                        )}
                        <span className="name-id">{data.kiddoBandID ? "#" + data.kiddoBandID : ""}</span>
                      </td>
                      {/* <td className="btn-lable text-center">
                        {loading ? (
                          <SkeletonLoading />
                        ) : (
                          <>
                              {data?.medicalCondition && <Badge
                              custom={CustomTable ? true : false}
                              // badgeType={`${data.alerttype}`}
                              badgeType={"success"}
                              customClass=""
                              label={`${data.medicalCondition[0] || "N/A"}`}
                              backgroundColor={
                                CustomTable
                                  ? mode !== "dark"
                                    ? backgroundColor
                                    : fontColor
                                    ? fontColor
                                    : "#000000"
                                  : ""
                              }
                              fontColor={
                                CustomTable
                                  ? mode === "dark"
                                    ? "#ffffff"
                                    : fontColor
                                  : ""
                              }
                            />}
                          </>
                          // data.medicalCondition.map((MedicalData: any) => (
                          // ))
                        )}
                      </td> */}
                      <td>
                        {/* <Badge
                          badgeType={`connected`}
                          // badgeType={`${data.deviceStatus}`}
                          customClass=""
                          label={`${capitalize(data.deviceStatus)}`}
                        /> */}
                        <span className="text-success text-end">{capitalize(data.kiddoBandStatus)}</span>
                      </td>
                      {/* <td className="text-center">
                        {loading ? (
                          <SkeletonLoading />
                        ) : (
                          <>
                            <span className="d-block percentage">
                              {data.kiddoadherence}
                            </span>
                            <span className="time text-thin">
                               {data.kiddodesc}
                            </span>
                          </>
                        )}
                      </td>
                      <td className="text-center">
                        {loading ? (
                          <SkeletonLoading />
                        ) : (
                          <>
                            <span className="d-block percentage">
                              {data.careadherence}
                            </span>
                            <span className="time text-thin">
                               {data.caredesc}
                            </span>
                          </>
                        )}
                      </td>
                      <td className="text-center">
                        {loading ? (
                          <SkeletonLoading />
                        ) : (
                          <span className="d-block percentage">
                              {data.mediadherence}
                          </span>
                        )}
                      </td> */}
                      {/* <td className="alert-cell">
                        {loading ? (
                          <SkeletonLoading />
                        ) : (
                          <>
                            <div className="d-flex fontMedium align-items-center mb-2">
                              <div className="img-label me-3">
                                <SVG
                                  src="Assets/Images/Icons/critical.svg"
                                  className={`fill-${data.alerttype}`}
                                  width="24"
                                  height="21"
                                />
                              </div>
                              <span>{data.alertscore}</span>
                            </div>
                            <span className="text-thin">
                              · {data.alertdesc}
                            </span>
                          </>
                        )}
                      </td> */}
                    </tr>
                  ))
              )
            ) : (
              loadingData
            )}
          </tbody>
        </table>
      </div>
      {!loading && isPagination ? (
        <Pagination
          dataLength={dataLength}
          page_number={page_number}
          page_size={rowsPerPage}
          setpage_number={setPageNumber}
        />
      ) : (
        ""
      )}
    </>
  );
}
